import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 左侧菜单栏数据
    manageMenuItems: [
      // {
      //   name: 'home', // 要跳转的路由名称 不是路径
      //   size: 18, // icon大小
      //   type: 'md-home', // icon类型
      //   text: '主页', // 文本内容
      // },
      {
        text: '账号管理',
        type: 'ios-paper',
        children: [{
          type: 'md-apps',
          name: 'distributeaccountSL',
          text: '水表（流量计）'
        },
        {
          type: 'md-apps',
          name: 'distributeaccountL',
          text: '流量计'
        },
        {
          type: 'md-apps',
          name: 'distributeaccountR',
          text: '热量表',
        },
        {
          type: 'md-apps',
          name: 'distributeaccount',
          text: '主页',
        }
      ]
      },
      {
        text: '表具管理',
        type: 'md-apps',
        children: [{
            type: 'md-apps',
            name: 'factoryversion',
            text: '表具出厂信息'
          },
          {
            type: 'md-apps',
            name: 'downsetting',
            text: '通信参数设置'
          },
          {
            type: 'md-apps',
            name: 'lastmessage',
            text: '表具最新数据',
          }
        ]
      },
      {
        text: '信息统计',
        type: 'md-apps',
        children: [{
            type: 'md-apps',
            name: 'meterreading',
            text: '上报成功率'
          },
          {
            type: 'md-apps',
            name: 'communicationsuccessrate',
            text: '通信成功率'
          },
          {
            type: 'md-apps',
            name: 'faultalarm',
            text: '故障报警',
          },
          // {
          //   type: 'md-apps',
          //   name: 'meterreadingfailure',
          //   text: '抄表失败',
          // }
        ]
      }
    ],
    menuItems: [{
        name: 'home', // 要跳转的路由名称 不是路径
        size: 18, // icon大小
        type: 'md-home', // icon类型
        text: '主页', // 文本内容
      },
      {
        text: '设备管理',
        type: 'md-apps',
        children: [
          {
            type: 'md-apps',
            name: 'meter',
            text: '设备管理'
          }
          // ,
          // {
          //   type: 'md-apps',
          //   name: 'downmessage',
          //   text: '参数下发',
          // }
        ]
      },
      {
        text: '数据报表',
        type: 'logo-buffer',
        children: [{
            type: 'md-timer',
            name: 'realtimedata',
            text: '实时数据',
          },
          {
            type: 'ios-timer',
            name: 'historydata',
            text: '历史数据',
          },
          {
            type: 'ios-book',
            name: 'settlement',
            text: '结算数据',
          },
          // {
          //   type: 'ios-book',
          //   name: 'meterreadingfailure2',
          //   text: '抄表失败',
          // }
          
        ]
      },
      {
        text: '监控报警',
        type: 'ios-paper',
        children: [{
            type: 'ios-paper',
            name: 'warn',
            text: '监控报警',
          }
        ]
      },
      {
        text: '账号管理',
        type: 'md-contacts',
        children: [{
            type: 'md-contacts',
            name: 'account',
            text: '账号管理',
          }
        ]
      }
    ],
  },
  mutations: {
    setMenus(state, items) {
      state.menuItems = [...items]
    },
  },
})

export default store
